// extracted by mini-css-extract-plugin
module.exports = {"thankyouWrapper":"thankyou_thankyouWrapper__2DtXO","heading":"thankyou_heading__xpn6X","content":"thankyou_content__2f0J1","buttonPosition":"thankyou_buttonPosition__ZVkeT"};